import { render, staticRenderFns } from "./item.vue?vue&type=template&id=422f3089&"
import script from "./item.vue?vue&type=script&lang=js&"
export * from "./item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yoreirei/Documents/project/other/market-ui/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('422f3089')) {
      api.createRecord('422f3089', component.options)
    } else {
      api.reload('422f3089', component.options)
    }
    module.hot.accept("./item.vue?vue&type=template&id=422f3089&", function () {
      api.rerender('422f3089', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/lib/dropdown/src/item.vue"
export default component.exports